import React from 'react';

export function Terms() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="prose prose-gray max-w-none">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
        <p className="text-gray-600 mb-8">Effective Date: Sep 17, 2024</p>
        
        <p className="text-gray-600 mb-8">
          Welcome to Ditto Wallet ("we," "our," "us"). By accessing or using our services through our wallet bot ("Bot") or website ("Site"), you agree to comply with and be bound by the following Terms of Service ("Terms"). Please read these Terms carefully. If you do not agree with these Terms, you should not use our services.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
        <p className="text-gray-600 mb-6">
          By accessing or using the Bot or the Site, you acknowledge that you have read, understood, and agree to be bound by these Terms. These Terms apply to all users of the Bot and the Site.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">2. Use of the Bot and Site</h2>
        <p className="text-gray-600 mb-6">
          The Bot and Site provide software services that allow users to interact with blockchain protocols and access useful information based on their on-chain wallet address. The services are provided "as is" and "as available" without any warranties or guarantees of any kind, either express or implied.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">3. User Responsibilities</h2>
        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
          <li>You are solely responsible for safeguarding your on-chain wallet and any interactions you make with blockchain protocols using the Bot or the Site.</li>
          <li>Your use of the Bot and Site, including any transactions, operations, or interactions you engage in on the blockchain, is at your own risk.</li>
          <li>You must ensure that your use of the Bot and Site complies with all applicable laws, regulations, and guidelines.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">4. No Warranty</h2>
        <p className="text-gray-600 mb-4">The Bot and Site are provided on an "as is" and "as available" basis without warranties of any kind, either express or implied. We do not warrant that:</p>
        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
          <li>The Bot or Site will function uninterrupted or error-free.</li>
          <li>The information provided by the Bot or Site is accurate, complete, or current.</li>
          <li>The Bot or Site is free of viruses or other harmful components.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">5. Assumption of Risk</h2>
        <p className="text-gray-600 mb-4">Using the Bot or Site to interact with blockchain protocols carries inherent risks. By using our services, you acknowledge and agree that:</p>
        <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
          <li>You assume all risks related to the use of blockchain technologies, including but not limited to transaction errors, smart contract malfunctions, or market risks.</li>
          <li>We are not liable for any losses, damages, or claims arising from your use of blockchain protocols, including losses due to user error, software malfunctions, technical failures, or regulatory changes.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p className="text-gray-600 mb-6">
          In no event shall we be liable to you or any third party for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to, loss of profits, data, or other intangible losses arising out of or in connection with your use of the Bot or Site, even if we have been advised of the possibility of such damages.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">7. Changes to These Terms</h2>
        <p className="text-gray-600 mb-6">
          We reserve the right to modify or replace these Terms at any time. Changes will be effective immediately upon posting within the Bot and on the Site. Your continued use of the Bot or Site following the posting of any changes to these Terms constitutes acceptance of those changes.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">8. Termination</h2>
        <p className="text-gray-600 mb-6">
          We reserve the right to terminate or suspend your access to the Bot and Site, without notice, for any reason, including breach of these Terms.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">9. Governing Law</h2>
        <p className="text-gray-600 mb-6">
          These Terms shall be governed by and construed in accordance with the federal laws of the United States, without regard to its conflict of law principles.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Us</h2>
        <p className="text-gray-600 mb-6">
          If you have any questions about these Terms, please contact us at{' '}
          <a 
            href="mailto:support@dittowallet.com"
            className="text-blue-600 hover:text-blue-700 transition-colors"
          >
            support@dittowallet.com
          </a>.
        </p>
      </div>
    </div>
  );
} 